var React = require('react');

function Press (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M208 320h-128C71.16 320 64 327.2 64 336S71.16 352 80 352h128c8.838 0 16-7.164 16-16S216.8 320 208 320zM304 224h-224C71.16 224 64 231.2 64 240S71.16 256 80 256h224C312.8 256 320 248.8 320 240S312.8 224 304 224zM304 128h-224C71.16 128 64 135.2 64 144S71.16 160 80 160h224C312.8 160 320 152.8 320 144S312.8 128 304 128zM320 0H64C28.65 0 0 28.65 0 64v384c0 35.35 28.65 64 64 64h256c35.35 0 64-28.65 64-64V64C384 28.65 355.3 0 320 0zM352 448c0 17.64-14.36 32-32 32H64c-17.64 0-32-14.36-32-32V64c0-17.64 14.36-32 32-32h256c17.64 0 32 14.36 32 32V448z"}));
}

Press.defaultProps = {"viewBox":"0 0 384 512"};

module.exports = Press;

Press.default = Press;
